import { fmtDate } from "@/lib/constants";
import { BrandTag } from "@/components/common";

const daysAgo = (d) => Math.max(0, Math.round((Date.now() - new Date(`${d}T00:00:00+05:30`)) / 864e5));

const TicketCard = ({ t, active, onClick }) => {
  const age = daysAgo(t.date);
  return (
    <button onClick={onClick} data-testid={`ticket-card-${t.id}`}
      className={`w-full rounded-2xl border p-4 text-left transition-[border-color,background-color,transform] hover:-translate-y-0.5 ${active ? "border-slate-900 bg-white shadow-sm" : "border-slate-200 bg-white hover:border-slate-300"}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="truncate font-semibold text-slate-900">{t.customer_name || t.customer_phone}</div>
          <div className="truncate text-xs text-slate-500">{t.outlet} · {fmtDate(t.date)}</div>
        </div>
        <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${age > 3 ? "bg-red-50 text-red-600" : "bg-slate-100 text-slate-600"}`}>{age}d</span>
      </div>
      <p className="mt-2 line-clamp-2 text-sm text-slate-600">{t.text || (t.rating != null ? `Rated ${t.rating} with no comment` : "No comment")}</p>
      <div className="mt-3 flex items-center justify-between gap-2">
        <BrandTag brand={t.brand} />
        {t.rating != null && <span className="text-xs font-semibold text-amber-600">{t.rating} ★</span>}
      </div>
    </button>
  );
};

export const TicketList = ({ items, activeId, onPick }) => (
  <div className="space-y-2" data-testid="ticket-list">
    {items.map((t) => <TicketCard key={t.id} t={t} active={t.id === activeId} onClick={() => onPick(t)} />)}
  </div>
);
